<mat-drawer #drawer class="org-drawer" mode="side" opened="true" position="end">
  <div class="drawer-header">
    <div class="title">{{ selectedItem?.orgCode }}</div>
    <button class="icon-button icon-close" type="button" (click)="toggleDrawer()"></button>
  </div>
  <div class="drawer-divider"></div>
  <div class="org-info-data">
    <div class="org-name">{{ selectedItem?.orgDescription }}</div>
    <div class="label-span">
      <label>ARE Code</label>
      <span>{{ selectedItem?.areCode || "N/A" }}</span>
    </div>
    @if (selectedItem?.assignedCountries?.length) {
      <div class="label-span">
        <label>{{ "responsible.item.assignedCountries" | translate }}</label>
        <span>{{ selectedItem?.assignedCountries?.join(", ") }}</span>
      </div>
    }
  </div>
  <div class="drawer-divider"></div>
  <div class="org-info-data">
    <div class="label-span">
      <label>{{ "responsible.item.executiveMember" | translate }}</label>
      <span>{{ responsible || "N/A" }}</span>
    </div>
    <div class="label-span">
      <label>{{ "responsible.item.specialistFunction" | translate }}</label>
      <span>{{ specialists || "N/A" }}</span>
    </div>
  </div>
  <div class="drawer-divider"></div>
  <app-org-drawer-reports />
</mat-drawer>
